/**
 * Minimal YAML-like frontmatter parser for help articles.
 * Expects:
 * ---
 * title: ...
 * summary: ...
 * ---
 * body...
 */
export function parseFrontmatter(raw) {
  const text = typeof raw === 'string' ? raw : '';
  const match = text.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/);

  if (!match) {
    return {
      meta: { title: 'Help', summary: '' },
      body: text.trim(),
    };
  }

  const meta = {};
  match[1].split(/\r?\n/).forEach((line) => {
    const idx = line.indexOf(':');
    if (idx === -1) return;
    const key = line.slice(0, idx).trim();
    let value = line.slice(idx + 1).trim();
    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }
    if (key) meta[key] = value;
  });

  return {
    meta: {
      title: meta.title || 'Help',
      summary: meta.summary || '',
      ...meta,
    },
    body: (match[2] || '').trim(),
  };
}
